import { useSnackbar } from 'notistack';
import { useMutation } from 'react-query';

import { axios } from 'lib';

const extractExtension = (name = '') => {
  const extensionDotIndex = name
    .split('')
    .reverse()
    .findIndex((char) => char === '.');

  if (!name || extensionDotIndex === -1) return null;

  return name.slice(-1 * extensionDotIndex);
};

const createFile = async ({ directID, tcId = null, cgId = null, name, file, skipWatermark }) => {
  let url = `/api/directs/${directID}/files`;
  let parentType = 'direct';
  if (tcId) {
    url = `/api/directs/${directID}/suppliers/${tcId}/files`;
    parentType = 'supplier';
  }

  if (cgId) {
    url = `/api/directs/${directID}/consortium_groups/${cgId}/files`;
    parentType = 'consortium_group';
  }
  const formData = new FormData();

  file.fileName = file.name;

  formData.append('name', name);
  formData.append('file', file);
  formData.append('parent_id', directID);
  formData.append('mime_type', file.type);
  formData.append('file_ext', extractExtension(file.name));
  formData.append('last_updated_user_id', '1');
  formData.append('parent_type', parentType);
  formData.append('skip_watermark', skipWatermark);

  const { data } = await axios.post(url, formData);

  return data;
};

export const useCreateFile = () => {
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    //@ts-ignore
    mutationFn: createFile,
    onSuccess: () => enqueueSnackbar('File succesfully uploaded', { variant: 'success' }),
    onError: (error) => {
      enqueueSnackbar(error?.message || 'Some error occured', { variant: 'error' });
    },
  });
};
